import { useAuth } from 'src/hooks';
import { validateUrl } from 'src/utils/urls';
import { useQuery, UseQueryResult } from 'react-query';

async function checkUrlValidOrNot({
  token,
  tokenType,
  url,
}: TVariables): Promise<APIResult> {
  const response = await fetch(validateUrl(url), {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}

type APIResult = {
  Data: UrlData;
  IsSuccess: boolean;
  StatusCode: number;
};

type UrlData = {
  Url: string;
  StatusCode: number;
  StatusDescription: string;
  IsAllowedByDB: boolean;
};

type TError = { message: string };
type TVariables = {
  token: string;
  tokenType: string;
  url: string | undefined;
};

function useValidateUrl(
  url: string | undefined,
): UseQueryResult<APIResult, TError> {
  const { token, tokenType } = useAuth();
  return useQuery(
    ['validate_url', url],
    async () => {
      if (url !== '' && url !== undefined) {
        const result = await checkUrlValidOrNot({
          token,
          tokenType,
          url,
        });

        if (result) return result;
      }
    },
    {
      refetchOnWindowFocus: false,
      enabled: false,
    },
  );
}
export { useValidateUrl };
